import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IOfferState } from './offer.state';

export class OfferSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly offerState = (state: IRootState): IOfferState => {
    return state.offer as IOfferState;
  };

  static readonly model = createSelector(OfferSelectors.offerState, (offer: IOfferState) => {
    return offer.model;
  });

  static readonly data = createSelector(OfferSelectors.offerState, (offer: IOfferState) => {
    return offer.data;
  });
}
